import React from "react";

export default function TequilaFrame4({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-teq41{fill:#158402}.cls-teq43{fill:#d6d00b}.cls-teq45{fill:#c8eac3}.cls-teq48{fill:#208e09}.cls-teq49{fill:#147a01}.cls-teq410{fill:#149100}.cls-teq412{fill:#abd3a5}.cls-teq413{fill:#e2fcde}.cls-teq414{fill:#eaea1b}.cls-teq415{fill:#efeb73}.cls-teq416{fill:#27a511}"
            }
          </style>
        </defs>
        <path
          d="M1645.99 1729.94H423.02c-73.33 0-132.99-59.66-132.99-132.99V373.98c0-73.33 59.66-132.99 132.99-132.99h1222.97c73.33 0 132.99 59.66 132.99 132.99v1222.97c0 73.33-59.66 132.99-132.99 132.99ZM423.02 284c-49.61 0-89.97 40.36-89.97 89.97v1222.97c0 49.61 40.36 89.97 89.97 89.97h1222.97c49.61 0 89.97-40.36 89.97-89.97V373.98c0-49.61-40.36-89.97-89.97-89.97H423.02Z"
          className="cls-teq414"
        />
        <ellipse
          cx={365.22}
          cy={1710.74}
          className="cls-teq414"
          rx={136.32}
          ry={33.43}
        />
        <path
          d="M579.86 1364.24c-9.26 20.54-23.55 31.68-29.62 36.07-43.14 31.26-95.07 8.92-101.36 6.09l3.24-25.2c33.62 8.82 48.63 2.2 56.04-6 23.59-26.05-12.12-84.52 12.66-114.51a33.18 33.18 0 0 1 10.11-8.22c.01 0 .02-.01.03-.02 10.74-5.71 23.96-5.53 33.73-.88.82.38 1.61.8 2.37 1.25 26.66 15.68 29.68 73.98 12.8 111.4Z"
          className="cls-teq410"
        />
        <path
          d="M397.29 1739.05c18.15 0 35.47-.67 51.31-1.89-23.07 4.39-52.06 7.01-83.53 7.01-75.28 0-136.31-14.96-136.31-33.43s61.03-33.43 136.31-33.43c48.46 0 91.02 6.2 115.19 15.55-22.98-3.33-51.75-5.32-82.97-5.32-75.28 0-136.31 11.54-136.31 25.76s61.03 25.76 136.31 25.76Z"
          className="cls-teq43"
        />
        <path
          d="M408.54 1641.15c-8.49 28.98-16.66 52.14-22.24 67.16-17.79-.5-35.58-.99-53.37-1.49-8.28-21.81-20.35-55.7-32.24-98.49-20.97-75.54-86.04-309.83-15.56-407.43 1.97-2.73 9.8-13.31 22.07-23.33 12-9.81 28.26-19.09 47.42-19.95 17.02-.77 33.42 5.24 46.74 14.23 5.6 3.77 10.65 8.08 14.97 12.63 73.16 76.96 31.78 321.57-7.78 456.67Z"
          className="cls-teq410"
        />
        <ellipse
          cx={302.77}
          cy={1291.29}
          className="cls-teq416"
          rx={35.08}
          ry={65.2}
        />
        <path
          d="M324.01 1459.68c3.92 32.05-.13 74.85-12.12 77.23-11.29 2.24-29.36-31.43-33.74-63.55-5.06-37.06 7.18-78.75 19.18-79.33 11.73-.56 23.32 38.13 26.68 65.65Z"
          className="cls-teq416"
        />
        <path
          d="M409.13 1641.15c-8.49 28.98-16.66 52.14-22.24 67.16-17.79-.5-35.58-.99-53.37-1.49-2.91-7.66-6.29-16.82-9.96-27.32 2.8 6.25 6.73 12.8 11.28 12.71 38.04-.82 99.7-464.37 6.67-505.17-18.33-8.04-39.28 1.81-53.45 10.74 3.55-4.55 10.34-12.55 19.72-20.21 12-9.81 28.26-19.09 47.42-19.95 17.02-.77 33.42 5.24 46.74 14.23 5.6 3.77 10.65 8.08 14.97 12.63 73.16 76.96 31.78 321.57-7.78 456.67Z"
          className="cls-teq41"
        />
        <path
          d="M332.94 1706.82c-8.95-32.43-20.57-80.59-28.67-140.15-10.35-76.09-9.96-134.2-8.34-134.35 1.72-.15 5.13 64.63 26.13 151.37 8.92 36.85 18.58 76.75 27.24 75.99 16.74-1.47 15.87-153.64 21.6-153.55 3.6.06 9.6 60.26 6.82 126.23-.92 21.94-2.44 35.63-.67 35.98 4.18.83 21.1-73.89 32.85-139.36 20.79-115.82 22.76-187.99 24.46-187.84 2.3.2 3.68 132.53-30.58 294.23-6.26 29.52-12.5 54.36-17.47 72.95-17.79-.5-35.58-.99-53.37-1.49Z"
          className="cls-teq49"
        />
        <path
          d="M422.68 1209.22c-.97.66-6.86-10.15-15.85-20.06-12.6-13.9-26.78-21.02-37.24-24.92 7.22 18.26 15.41 45.05 16.96 78.11 1.54 33.03-3.97 63.03-5.56 62.92-1.36-.1.71-22.14-1.67-49.24-3.32-37.78-13.74-68.01-22.79-88.76-14.55 32.05-32.05 79.67-38.64 139.52-7.44 67.54 2.58 118.11 1.39 118.23-1.38.14-17.33-67.88-5.56-151.36a421.086 421.086 0 0 1 30.02-107.3c-6.72 2.59-15.29 6.81-23.91 13.98-26.25 21.86-32.04 53.75-33.35 53.19-1.27-.54 1-31.64 20.72-55.97 12-9.81 28.26-19.09 47.42-19.95 17.02-.77 33.42 5.24 46.74 14.23 5.68 6.01 9.33 11.51 10.77 13.67 7.16 10.8 11.55 23.04 10.56 23.71Z"
          className="cls-teq49"
        />
        <path
          d="M383.21 1178.83c1.24-.87 15.66 13.52 21.12 35.87 5.98 24.48-1.62 46.94-2.78 46.81-.88-.1 2.04-13.22-.56-32.22-4.21-30.76-19.14-49.51-17.79-50.46Z"
          className="cls-teq49"
        />
        <ellipse
          cx={532.67}
          cy={1301.11}
          className="cls-teq416"
          rx={18.8}
          ry={31.94}
        />
        <path
          d="M579.86 1364.24c-9.26 20.54-23.55 31.68-29.62 36.07-43.14 31.26-95.07 8.92-101.36 6.09.42-3.32.85-6.65 1.28-9.97 18.19 5.05 49.46 9.07 76.83-10.75 5.48-3.97 18.4-14.04 26.77-32.6 15.26-33.83 12.53-86.52-11.57-100.7-.69-.4-1.4-.79-2.14-1.13-1.01-.48-2.06-.91-3.15-1.28 9.4-3.02 19.76-2.21 27.79 1.61.82.38 1.61.8 2.37 1.25 26.66 15.68 29.68 73.98 12.8 111.4Z"
          className="cls-teq41"
        />
        <path
          d="M574.45 1267.37c-.43.29-2.43-4.01-6.36-8.06-4.29-4.41-9.09-6.71-12.96-7.99 2.89 6.47 6.34 16.44 6.67 28.88.36 13.51-3.06 25.9-4.11 25.77-.86-.11.3-8.67-.67-19.79-1.33-15.18-5.52-27.33-9.16-35.66-5.85 12.88-12.87 32.01-15.52 56.06-3.02 27.42 1.45 47.39.56 47.51-1.05.14-9.01-27.53-4.6-60.67a145.22 145.22 0 0 1 12.44-42.43 33.3 33.3 0 0 0-7.62 4.78c-10.13 8.48-13.28 21.42-13.4 21.38-.51-.22.4-12.71 8.32-22.49.9-.74 1.87-1.47 2.89-2.17.01 0 .02-.01.03-.02 10.74-5.71 23.96-5.53 33.73-.88.4.25.8.51 1.19.77 2.29 2.42 3.75 4.62 4.33 5.49 2.88 4.34 4.64 9.26 4.24 9.52ZM312.47 1212.07c-1.39-1.32-17.59 20.57-23.72 54.58-6.72 37.26 1.82 71.44 3.12 71.23.99-.16-2.29-20.12.62-49.03 4.73-46.81 21.5-75.34 19.98-76.78ZM358.75 1183.08c2.48.2-.69 67.78-1.67 88.75-.71 15.2-1.97 41.35-3.35 41.34-1.35-.01-2.14-25.08-2.21-27.36-1.62-52.89 5.09-102.91 7.23-102.74ZM333.2 1485.97c2.48-.37 10.14 73.86 12.52 96.9 1.72 16.7 4.66 45.43 3.3 45.74-1.33.3-6.12-26.77-6.55-29.22-10.04-57.13-11.41-113.1-9.27-113.41ZM405.52 1390.44c-2.83-.22-10.94 72.33-13.45 94.85-1.82 16.32-4.93 44.4-3.37 44.63 1.52.23 6.75-26.34 7.22-28.75 10.96-56.06 12.05-110.54 9.6-110.73ZM454.09 1402.69c9.02 4.41 43.28 19.78 75.88 2.89 23.77-12.31 36.24-36.69 35.86-37.08-.38-.39-13.01 22.59-37.52 32.37-26.22 10.46-52.54.45-52.47-.84.05-.89 12.52 2.29 26.83-4.44 13.64-6.41 22.07-18.58 21.19-19.79-.92-1.27-11.38 10.56-28.25 16.03-15.41 4.99-29.91 2.96-40.68-.07-.28 3.65-.56 7.29-.83 10.94Z"
          className="cls-teq49"
        />
        <path
          d="M565.55 1266.67c-.76.39 4.11 9.18 6.12 22.19 3.5 22.69-4.58 39.49-3.61 39.82 1.04.35 11.92-18.55 8.06-39.51-2.39-12.98-9.73-22.93-10.56-22.49Z"
          className="cls-teq49"
        />
        <path
          d="M129.04 1279.92c9.26 20.54 23.55 31.68 29.62 36.07 43.14 31.26 95.07 8.92 101.36 6.09l-3.24-25.2c-33.62 8.82-48.63 2.2-56.04-6-23.59-26.05 12.12-84.52-12.66-114.51a33.18 33.18 0 0 0-10.11-8.22c-.01 0-.02-.01-.03-.02-10.74-5.71-23.96-5.53-33.73-.88-.82.38-1.61.8-2.37 1.25-26.66 15.68-29.68 73.98-12.8 111.4Z"
          className="cls-teq410"
        />
        <ellipse
          cx={179.97}
          cy={1211.31}
          className="cls-teq416"
          rx={15.2}
          ry={25.84}
        />
        <path
          d="M129.04 1279.91c9.38 20.8 24.07 32.04 29.62 36.07 40.62 29.52 87.99 11.47 94.6 8.82-.02-1.8.02-3.73.14-5.76.17-2.85.48-5.48.87-7.86-6.49 2.43-17.18 5.49-30.5 4.87-22.12-1.01-37.45-11.51-41.86-14.7-5.48-3.97-18.4-14.04-26.77-32.6-15.26-33.83-12.53-86.52 11.57-100.7.69-.4 1.4-.79 2.14-1.13 1.01-.48 2.06-.91 3.15-1.28-9.4-3.02-19.76-2.21-27.79 1.61-.82.38-1.61.8-2.37 1.25-26.66 15.68-29.68 73.98-12.8 111.4Z"
          className="cls-teq41"
        />
        <path
          d="M134.46 1183.05c.43.29 2.43-4.01 6.36-8.06 4.29-4.41 9.09-6.71 12.96-7.99-2.89 6.47-6.34 16.44-6.67 28.88-.36 13.51 3.06 25.9 4.11 25.77.86-.11-.3-8.67.67-19.79 1.33-15.18 5.52-27.33 9.16-35.66 5.85 12.88 12.87 32.01 15.52 56.06 3.02 27.42-1.45 47.39-.56 47.51 1.05.14 9.01-27.53 4.6-60.67a145.22 145.22 0 0 0-12.44-42.43 33.3 33.3 0 0 1 7.62 4.78c10.13 8.48 13.28 21.42 13.4 21.38.51-.22-.4-12.71-8.32-22.49-.9-.74-1.87-1.47-2.89-2.17-.01 0-.02-.01-.03-.02-10.74-5.71-23.96-5.53-33.73-.88-.4.25-.8.51-1.19.77-2.29 2.42-3.75 4.62-4.33 5.49-2.88 4.34-4.64 9.26-4.24 9.52ZM253.4 1319.04c-12.19 5.48-44.31 17.75-74.47 2.21-23.83-12.28-36.25-36.68-35.86-37.08.38-.39 13.01 22.59 37.52 32.37 26.22 10.46 52.54.45 52.47-.84-.05-.89-12.52 2.29-26.83-4.44-13.64-6.41-22.07-18.58-21.19-19.79.92-1.26 11.44 10.73 28.25 16.03 15.31 4.83 29.88 2.24 40.94-1.47l-.84 13.01Z"
          className="cls-teq49"
        />
        <path
          d="M143.35 1182.35c.76.39-4.11 9.18-6.12 22.19-3.5 22.69 4.58 39.49 3.61 39.82-1.04.35-11.92-18.55-8.06-39.51 2.39-12.98 9.73-22.93 10.56-22.49Z"
          className="cls-teq49"
        />
        <path
          d="M136.48 1516.44c11.21 24.87 28.52 38.35 35.86 43.67 52.24 37.84 115.11 10.8 122.72 7.37-1.3-10.17-2.61-20.34-3.92-30.51-40.71 10.68-58.87 2.67-67.85-7.26-28.56-31.54 14.67-102.33-15.33-138.63a40.21 40.21 0 0 0-12.24-9.95c-.01 0-.02-.01-.03-.02-13-6.92-29-6.69-40.83-1.06-.99.46-1.94.97-2.87 1.51-32.27 18.98-35.94 89.56-15.5 134.88Z"
          className="cls-teq410"
        />
        <path
          d="M290.37 1568.8c-7.62 3.29-67.42 27.93-118.03-8.68-6.18-4.47-24.32-18.1-35.86-43.67-20.44-45.32-16.77-115.9 15.5-134.88.93-.54 1.88-1.05 2.87-1.51 11.83-5.64 27.83-5.86 40.84 1.06.01 0 .02.01.03.02.45.24.89.48 1.33.74-5.91.02-11.67 1.29-16.6 3.64-.86.4-1.69.85-2.49 1.32-28.06 16.51-31.24 77.87-13.48 117.26 10.54 23.37 27.2 35.17 31.17 37.97 39.69 27.99 84.66 10.2 90.55 7.75 1.39 6.33 2.78 12.66 4.17 19Z"
          className="cls-teq41"
        />
        <ellipse
          cx={198.65}
          cy={1432.93}
          className="cls-teq416"
          rx={18.8}
          ry={31.94}
        />
        <path
          d="M143.04 1399.16c.52.35 2.94-4.85 7.7-9.76 5.19-5.34 11.01-8.12 15.69-9.68-3.49 7.83-7.67 19.91-8.08 34.96-.44 16.36 3.71 31.36 4.97 31.2 1.04-.13-.37-10.49.81-23.95 1.61-18.38 6.68-33.09 11.09-43.17 7.08 15.59 15.59 38.76 18.8 67.87 3.66 33.19-1.75 57.37-.68 57.52 1.27.17 10.9-33.33 5.57-73.45a175.567 175.567 0 0 0-15.06-51.37c2.53 1.14 5.82 2.94 9.23 5.79 12.27 10.27 16.08 25.94 16.22 25.88.62-.27-.48-15.39-10.08-27.23a52.34 52.34 0 0 0-3.5-2.63c-.01 0-.02-.01-.03-.02-13-6.92-29-6.69-40.83-1.06-.49.3-.97.61-1.44.93-2.77 2.93-4.54 5.6-5.24 6.65-3.49 5.25-5.62 11.21-5.13 11.53ZM288.76 1562.99c-10.92 5.34-52.41 23.94-91.87 3.5-28.78-14.91-43.88-44.42-43.41-44.9.46-.47 15.75 27.35 45.43 39.19 31.74 12.67 63.61.55 63.52-1.02-.06-1.08-15.16 2.77-32.49-5.37-16.52-7.76-26.72-22.5-25.65-23.96 1.1-1.52 13.78 12.92 34.21 19.41 18.11 5.76 35.25 3.03 48.12-.94.71 4.7 1.43 9.4 2.14 14.1Z"
          className="cls-teq49"
        />
        <path
          d="M153.81 1398.31c.92.48-4.97 11.12-7.4 26.86-4.24 27.47 5.54 47.81 4.37 48.21-1.26.42-14.43-22.46-9.76-47.84 2.89-15.72 11.78-27.76 12.79-27.23Z"
          className="cls-teq49"
        />
        <path
          d="M422.82 1712.26c.23 3.73-26.65 11.4-56.7 11.4-6.12 0-54.28 1.54-56.7-11.4-.96-5.12 4.6-12.11 10.42-14.13 8.14-2.83 11.85 5.72 22.93 6.38 14.34.86 17.89-12.86 31.69-11.4 7.52.8 7.43 4.98 20.43 10.94 16.66 7.64 27.79 5.82 27.93 8.21Z"
          className="cls-teq414"
        />
        <path
          d="M422.82 1712.26c.05.89-1.44 2.01-4.15 3.18-3.54-.97-13.27-1.08-26.47-7.14-13-5.96-12.91-10.14-20.43-10.94-13.79-1.46-17.35 12.26-31.69 11.4-11.08-.67-14.8-9.21-22.93-6.39-2.58.9-5.11 2.77-7.04 5.02 1.66-3.96 5.63-7.85 9.72-9.27 8.14-2.83 11.85 5.72 22.93 6.39 14.34.86 17.9-12.86 31.69-11.4 7.52.8 7.44 4.98 20.43 10.94 16.66 7.64 27.78 5.82 27.93 8.21Z"
          className="cls-teq43"
        />
        <path
          d="M1816.53 1596.51c5.67-84.38 34-151.76 57.89-195.96h-263.14c23.89 44.19 52.22 111.58 57.89 195.96 3.87 57.55-3.87 107.06-13.71 145.14h174.77c-9.84-38.08-17.58-87.59-13.71-145.14Z"
          className="cls-teq45"
        />
        <path
          d="M1838.46 1478.46c-46.55 128.65-33.02 204.1-81.8 220.66-1.6.54-21.16 6.91-39.88 0-49.46-18.26-27.48-105.01-69.54-220.66-12.81-35.23-27.56-62.1-35.96-76.45 15.72 56.12 29.47 120.72 37.35 192.63 5.85 53.47 7.61 103.22 6.84 148.47h174.77c-1.91-34.4-2.7-86.12 4.76-148.47 12.99-108.48 44.8-191.32 39.42-192.63-3.53-.86-20.57 33.93-35.96 76.45Z"
          className="cls-teq412"
        />
        <ellipse
          cx={1743.16}
          cy={1401.85}
          className="cls-teq412"
          rx={131.57}
          ry={30}
        />
        <ellipse
          cx={1742.85}
          cy={1402.28}
          className="cls-teq413"
          rx={114}
          ry={22.63}
        />
        <path
          d="M1832.9 1750.66c-21.5 4.08-52.13 8.3-89.24 8.36-37.88.06-69.11-4.24-90.85-8.36v-27.1c0-5.56 7.74-9.78 16.29-8.91 20.48 2.08 44.08 3.59 70.23 3.72 29.06.14 55.09-1.46 77.33-3.73 8.53-.87 16.24 3.37 16.24 8.92v27.1Z"
          className="cls-teq45"
        />
        <path
          d="M1832.9 1732.27v7.69c0-7.3-7.71-12.88-16.24-11.74a555.107 555.107 0 0 1-77.33 4.9c-26.15-.17-49.75-2.15-70.23-4.9-8.55-1.14-16.29 4.42-16.29 11.73v-7.69c0-7.31 7.74-12.87 16.29-11.73 20.48 2.74 44.08 4.73 70.23 4.9 29.06.18 55.09-1.93 77.33-4.9 8.53-1.14 16.24 4.43 16.24 11.73Z"
          className="cls-teq412"
        />
        <path
          d="M1730.5 1467.35c-31.84.46-59.92 4.03-83.25 8.49 2.97 17.1 7.26 43.39 11.34 75.65 12.46 98.63 6.94 126.36 30.3 145.69 24.82 20.54 71.33 22.58 97.77 3.77 23.61-16.8 21.38-43.23 39.72-154.56 4.83-29.29 9.21-53.13 12.09-68.38a481.282 481.282 0 0 0-107.97-10.67Z"
          className="cls-teq414"
        />
        <ellipse
          cx={1742.85}
          cy={1478.46}
          rx={95.61}
          ry={13.19}
          style={{
            fill: "#f7f24d",
          }}
        />
        <path
          d="M1728.57 1476.02c-.14 2.24-18.45 3.49-26.67 3.81-8.5.33-26.76.44-26.99-1.8-.2-1.93 13.11-5.64 26.33-6.19 13.69-.57 27.45 2.22 27.33 4.18Z"
          style={{
            fill: "#f4ee7a",
          }}
        />
        <ellipse
          cx={1706.53}
          cy={1559.27}
          className="cls-teq415"
          rx={13.37}
          ry={10.58}
          transform="rotate(-40.33 1706.517 1559.264)"
        />
        <ellipse
          cx={1688.39}
          cy={1620.74}
          className="cls-teq415"
          rx={5.85}
          ry={36.63}
        />
        <ellipse
          cx={1789.27}
          cy={1562}
          className="cls-teq43"
          rx={12.35}
          ry={58.74}
        />
        <ellipse
          cx={1679.13}
          cy={1445.54}
          className="cls-teq413"
          rx={26.32}
          ry={8.53}
        />
        <path
          d="m1606.71 1306.46 50.97 5.82c-13.02 51.93 10.38 99.66 43.68 112.11 40.49 15.13 107.57-17.41 122.43-86.64 19.21 2.51 38.42 5.01 57.63 7.52-2.05 12.83-7.44 33.39-21.67 54.52-29.36 43.59-82.5 69.25-137.98 61.41-75.86-10.72-127.37-80-115.06-154.74Z"
          className="cls-teq410"
        />
        <path
          d="M1620.56 1308.42c36.92 3.85 73.83 7.69 110.75 11.54 11.97 1.73 23.94 3.47 35.91 5.2 33.25 6.02 66.49 12.05 99.74 18.07-11.14 65.14-75.43 110.73-142.75 101.22-65.62-9.27-110.64-69.29-103.66-136.03Z"
          style={{
            fill: "#81e26d",
          }}
        />
        <path
          d="M1763.03 1337.83c2.28-3.78 10.12-1.83 41.96 2.99 36.65 5.55 45.9 5.94 48.69 12.75 2.51 6.1-1.9 13.11-9.44 25.1-8.07 12.83-13.99 22.25-22.78 23.22-5.75.64-10.65-2.57-36.37-32.31-21.68-25.07-23.66-29.11-22.06-31.75Z"
          className="cls-teq416"
        />
        <path
          d="M1763.03 1337.83c2.28-3.78 10.12-1.83 41.96 2.99 36.65 5.55 45.9 5.94 48.7 12.75 2.51 6.1-1.9 13.11-9.45 25.1-8.07 12.83-13.99 22.25-22.78 23.22-.71.08-1.41.1-2.14.01 4.26-4.16 8.25-10.51 12.98-18.02 7.54-11.99 11.95-19 9.44-25.1-2.8-6.81-12.04-7.21-48.7-12.76-14.18-2.15-23.6-3.72-29.89-4.47-.8-1.85-.66-2.86-.14-3.72Z"
          className="cls-teq48"
        />
        <path
          d="M1747.95 1347.08c4.35-1.18 8.45 5.54 27.37 30.59 21.77 28.84 27.99 35.39 25.02 42.21-2.66 6.11-10.85 8.19-24.85 11.74-14.98 3.8-25.98 6.59-32.87 1.34-4.5-3.43-5.64-9.07-2.17-47.99 2.92-32.8 4.46-37.07 7.5-37.89Z"
          className="cls-teq416"
        />
        <path
          d="M1745.21 1350.22c.81-2.16 1.69-2.85 2.74-3.14 4.35-1.18 8.45 5.54 27.37 30.59 21.77 28.85 27.99 35.39 25.02 42.21-2.66 6.11-10.85 8.19-24.85 11.74-13.47 3.42-23.71 6.02-30.64 2.7 5.68-.4 12.5-2.13 20.43-4.14 14-3.55 22.19-5.63 24.85-11.74 2.97-6.82-3.25-13.37-25.03-42.21-10.08-13.35-15.95-21.5-19.9-26.01Z"
          className="cls-teq48"
        />
        <path
          d="M1722.29 1332.08c-.96-4.24-9.07-4.54-41.02-8.73-36.77-4.82-45.72-7-50.59-1.27-4.36 5.13-2.41 13.04.93 26.57 3.57 14.47 6.19 25.1 14.27 28.45 5.28 2.19 10.99.49 45.12-20.79 28.76-17.94 31.96-21.25 31.28-24.22Z"
          className="cls-teq416"
        />
        <path
          d="M1630.18 1322.73c.49 4.07 1.72 9.03 3.22 15.13 3.57 14.48 6.19 25.1 14.27 28.45 5.28 2.19 10.99.49 45.12-20.79 13.04-8.13 20.82-13.25 25.37-16.71 2.65.84 3.81 1.83 4.14 3.27.67 2.97-2.52 6.28-31.28 24.22-34.13 21.28-39.85 22.99-45.12 20.79-8.08-3.35-10.7-13.98-14.27-28.45-3.2-12.96-5.13-20.77-1.44-25.91Z"
          className="cls-teq48"
        />
        <path
          d="M1733.71 1345.07c-3.77-2.33-9.85 2.95-35.97 21.65-30.07 21.52-38.12 26.05-37.48 33.38.57 6.57 7.72 10.81 19.94 18.07 13.08 7.77 22.68 13.47 30.94 10.36 5.41-2.03 8.3-7.1 17.53-45.21 7.78-32.12 7.68-36.61 5.04-38.24Z"
          className="cls-teq416"
        />
        <path
          d="M1660.25 1399.91c3.37 2.75 8.16 5.59 14.17 9.15 13.08 7.77 22.67 13.47 30.94 10.36 5.4-2.03 8.3-7.11 17.53-45.21 3.53-14.59 5.44-23.47 6.22-28.99 2.09-.87 3.45-.87 4.61-.16 2.64 1.63 2.73 6.13-5.05 38.24-9.23 38.1-12.12 43.18-17.53 45.21-8.27 3.11-17.86-2.59-30.94-10.36-12.22-7.26-19.36-11.5-19.94-18.07 0-.06 0-.12-.01-.18Z"
          className="cls-teq48"
        />
        <path
          d="M1624.22 1397.51c10.86 3.54 22.3 6.73 34.32 9.45 77.95 17.65 148.35 8.08 200.22-5.71-4.26 6.44-8.51 12.88-12.77 19.32a470.953 470.953 0 0 1-101.74 11.67c-40.87.21-75.88-4.93-103-10.85a38.383 38.383 0 0 1-11.32-10.85 38.428 38.428 0 0 1-5.71-13.02Z"
          className="cls-teq412"
          style={{
            opacity: 0.67,
          }}
        />
        <path
          d="M1641.24 1421.38c-.23 1.39 16.17 42.95 16.86 42.72.69-.23 171.36 0 171.36 0l19.4-44.39a467.443 467.443 0 0 1-104.62 12.52c-40.91.25-75.92-4.91-103-10.85Z"
          className="cls-teq45"
          style={{
            opacity: 0.51,
          }}
        />
        {children}
      </g>
    </svg>
  );
}
